<template>
    <div>
        <h2 class="headline">Behandling</h2>

        <form @submit.prevent id="alertInformation-details" autocomplete="off">
            <div class="form-group k3-form fullscreen">
                <input-wrapper
                    v-if="!fieldsDeactivated"
                    name="ascertainedDate"
                    v-model="form.ascertainedDate"
                    :colspan="8"
                    :component="widgets.DateWidget"
                    label="Fastställandedatum"
                />
                <input-wrapper
                    v-if="!fieldsDeactivated"
                    name="verifiedTime"
                    v-model="form.verifiedTime"
                    :colspan="8"
                    :component="widgets.DateWidget"
                    label="Verifierat datum"
                />
                <div class="colspan c8">
                    <h4>Giltighetstid</h4>
                </div>
                <input-wrapper
                    name="validityTimePeriodStart"
                    v-model="form.validityTimePeriodStart"
                    :colspan="3"
                    :component="widgets.DateWidget"
                    :required="true"
                    label="Från"
                />
                <input-wrapper
                    name="validityTimePeriodEnd"
                    v-model="form.validityTimePeriodEnd"
                    :colspan="3"
                    :component="widgets.DateWidget"
                    :required="false"
                    label="Till"
                />
                <input-wrapper
                    v-if="!fieldsDeactivated"
                    name="comment"
                    v-model="form.comment"
                    :colspan="8"
                    :component="widgets.TextAreaWidget"
                    :maxlength="140"
                    label="Kommentar"
                />
                <input-wrapper
                    name="description"
                    v-model="form.description"
                    :colspan="8"
                    :component="widgets.TextAreaWidget"
                    :maxlength="140"
                    :required="true"
                    label="Beskrivning"
                />
                <input-wrapper
                    name="code"
                    v-model="form.code"
                    :colspan="8"
                    :component="widgets.SuggestWidget"
                    apisearch="/core/kodverk/kvakoder/"
                    label="KVÅ-kod"
                    :displayCode="true"
                />
                <input-wrapper
                    name="Läkemedelsbehandling"
                    v-model="form.pharmaceuticalTreatment"
                    :colspan="8"
                    :component="widgets.ExpandableSuggest"
                    apisearch="/sil/atc/"
                    label="Läkemedelsbehandling"
                    :displayCode="true"
                />
            </div>
            <ButtonGroup>
                <Button type="button" @click="sign" size="primary">
                    <img src="@/assets/sign_white.svg" />Signera
                </Button>
                <Button @click="save" type="button" size="primary">
                    <img src="@/assets/send_white.svg" />Spara uppmärksamhetssignal
                </Button>
                <Button type="button" @click="cancel" variant="contour" size="secondary">Avbryt</Button>
            </ButtonGroup>
        </form>
    </div>
</template>

<script>
    import widgets from "@/components/widgets/inputs";
    import InputWrapper from "@/components/widgets/inputs/InputWrapper.vue";
    import linkEvents from "@/linkEvents";
    import ButtonGroup from "@/components/ButtonGroup.vue";
    import Button from "@/components/Button.vue";
    import { isEqual } from "lodash";
    import { removeEmptyOptions } from "@/tabs/AlertInformation/alertInformation";

    const createDefaultForm = () => ({
        ascertainedDate: null,
        verifiedTime: null,
        validityTimePeriodStart: new Date().toLocaleDateString("sv-SE"),
        validityTimePeriodEnd: null,
        comment: "",
        description: "",
        code: "",
        pharmaceuticalTreatment: [],
        type: "t",
    });
    export default {
        name: "treatmentForm",
        props: ["chosenComponent", "alertInformationForm"],
        components: {
            Button,
            ButtonGroup,
            InputWrapper,
        },
        data() {
            return {
                form: createDefaultForm(),
                widgets: widgets,
                fieldsDeactivated: true,
            };
        },
        computed: {
            hasUnsavedData() {
                return !isEqual(createDefaultForm(), this.form);
            },
        },
        watch: {
            hasUnsavedData(value) {
                this.$emit("hasUnsavedData", value);
            },
        },
        methods: {
            cancel() {
                this.$emit("cancelAlertForm");
            },
            save() {
                if (!this.validateForm("alertInformation-details")) {
                    return;
                }

                if (this.form.validityTimePeriodEnd === "") {
                    this.form.validityTimePeriodEnd = null;
                }

                const filteredForm = removeEmptyOptions(this.form, ["pharmaceuticalTreatment"]);
                this.$emit("save", filteredForm);
            },
            sign() {
                if (!this.validateForm("alertInformation-details")) {
                    return;
                }
                if (this.form.validityTimePeriodEnd === "") {
                    this.form.validityTimePeriodEnd = null;
                }
                const filteredForm = removeEmptyOptions(this.form, ["pharmaceuticalTreatment"]);
                this.$emit("sign", filteredForm);
            },
            validateForm(formName) {
                const form = document.getElementById(formName);
                if (form.checkValidity() === true) return true;
                else {
                    const list = form.querySelectorAll(":invalid");
                    for (let item of list) {
                        item.focus();
                        item.blur();
                    }
                    form.querySelector(":invalid").focus();
                }
                return false;
            },
        },
        created() {
            linkEvents.$on("theTreatments_changed", this.update);
        },
    };
</script>

<style lang="sass" scoped>
    #receiver-details
        position: relative
        min-height: 600px
        min-width: 600px
        display: inline-block

    h2
        margin: 10px 0px 10px 0px !important

    .radiobutton-line
        display: inline-block
        margin-top: 12px
        margin-bottom: 30px

        label:not(:first-of-type)
            margin-left: 32px

    .btn-group
        float: none !important

    .headline
        margin-bottom: 20px !important
</style>
